import React from 'react';

const StreakMeter = ({ 
  trades = [],
  maxDisplay = 20
}) => {
  // trades array: [{type: 'profit', amount: 100}, {type: 'loss', amount: -50}, ...]
  const displayTrades = trades.slice(-maxDisplay);

  return (
      <div
    className="
      glass-card
      rounded-3xl shadow-2xl p-6
      border border-border
      transition-all duration-300
      hover:shadow-orange-600/40
      active:shadow-orange-600/40
      focus-within:shadow-orange-600/40
    "
  >
      {/* Inner content gutter to prevent edge collisions */}
      <div className="relative z-10 h-full flex flex-col px-2">

        {/* Title */}
        <h3 className="text-lg font-semibold mb-4 text-foreground px-1">
          Win/Loss Streak
        </h3>

        {/* Streak dots / empty state */}
        <div className="flex flex-1 items-center justify-center">
          {displayTrades.length === 0 ? (
            <div className="text-center px-2">
              <span className="text-muted-foreground text-sm">
                No trades yet
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-2 flex-wrap max-w-full">
              {displayTrades.map((trade, idx) => (
                <div
                  key={idx}
                  className="w-3 h-3 rounded-full transition-transform hover:scale-125"
                  style={{
                    backgroundColor: trade.type === 'profit' ? '#10b981' : '#ef4444',
                    boxShadow: `0 2px 4px ${
                      trade.type === 'profit'
                        ? 'rgba(16, 185, 129, 0.3)'
                        : 'rgba(239, 68, 68, 0.3)'
                    }`,
                    cursor: 'pointer'
                  }}
                  title={`${trade.type === 'profit' ? 'Profit' : 'Loss'}: ₹${Math.abs(trade.amount)}`}
                />
              ))}
            </div>
          )}
        </div>

        {/* Legend */}
        <div className="flex justify-between mt-4 text-xs text-muted-foreground px-1">
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 rounded-full bg-green-500"></div>
            <span>Profit</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 rounded-full bg-red-500"></div>
            <span>Loss</span>
          </div>
          <span className="font-medium">
            {displayTrades.length} / {maxDisplay} shown
          </span>
        </div>

      </div>
    </div>
  );
};

export default StreakMeter;
